import { useHistory } from 'react-router-dom';

//TODO: REFACTOR IN UPDATE REACT
const useBackButton = () => {
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
  };

  return { handleBack };
};

export default useBackButton;
